export const GET_FORM_DATA = 'GET_FORM_DATA'
export const GET_FORM_DATA_FAILED = 'GET_FORM_DATA_FAILED'
export const GET_FORM_DATA_SUCCEEDED = 'GET_FORM_DATA_SUCCEEDED'
export const GET_REQUEST_PROMO_CODE = 'GET_REQUEST_PROMO_CODE'
export const GET_REQUEST_PROMO_CODE_FAILED = 'GET_REQUEST_PROMO_CODE_FAILED'
export const GET_REQUEST_PROMO_CODE_SUCCEEDED = 'GET_REQUEST_PROMO_CODE_SUCCEEDED'
